var _mask, _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEnd({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 44,
    viewBox: "0 0 35 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-outside-1",
    maskUnits: "userSpaceOnUse",
    x: 0.730469,
    y: 2,
    width: 34,
    height: 42,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 0.730469,
    y: 2,
    width: 34,
    height: 42
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.73047 18.9765C1.73047 10.1457 8.79526 3 17.5107 3C26.2041 3 33.2689 10.1457 33.2689 18.9765C33.2689 24.5011 30.4738 29.0445 26.3142 32.2228C22.3306 35.273 20.0637 39.1765 18.8312 42.1201C18.347 43.2933 16.6524 43.2933 16.1682 42.1201C14.9357 39.1978 12.6908 35.273 8.68522 32.2228C4.52557 29.0445 1.73047 24.4798 1.73047 18.9765Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.73047 18.9765C1.73047 10.1457 8.79526 3 17.5107 3C26.2041 3 33.2689 10.1457 33.2689 18.9765C33.2689 24.5011 30.4738 29.0445 26.3142 32.2228C22.3306 35.273 20.0637 39.1765 18.8312 42.1201C18.347 43.2933 16.6524 43.2933 16.1682 42.1201C14.9357 39.1978 12.6908 35.273 8.68522 32.2228C4.52557 29.0445 1.73047 24.4798 1.73047 18.9765Z",
    fill: "#8FD36E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3142 32.2228L25.7071 31.4282L25.7062 31.4288L26.3142 32.2228ZM18.8312 42.1201L17.9088 41.7339L17.9069 41.7386L18.8312 42.1201ZM16.1682 42.1201L17.0926 41.7386L17.0896 41.7315L16.1682 42.1201ZM8.68522 32.2228L8.07809 33.0174L8.07938 33.0184L8.68522 32.2228ZM17.5107 2C8.23164 2 0.730469 9.60484 0.730469 18.9765H2.73047C2.73047 10.6866 9.35888 4 17.5107 4V2ZM34.2689 18.9765C34.2689 9.60575 26.7687 2 17.5107 2V4C25.6396 4 32.2689 10.6857 32.2689 18.9765H34.2689ZM26.9213 33.0174C31.2766 29.6896 34.2689 24.8728 34.2689 18.9765H32.2689C32.2689 24.1295 29.6711 28.3994 25.7071 31.4282L26.9213 33.0174ZM19.7536 42.5063C20.9428 39.6663 23.1194 35.9285 26.9221 33.0167L25.7062 31.4288C21.5418 34.6175 19.1847 38.6867 17.9088 41.7339L19.7536 42.5063ZM15.2438 42.5016C16.0683 44.4995 18.931 44.4995 19.7556 42.5016L17.9069 41.7386C17.8377 41.9062 17.6902 42 17.4997 42C17.3092 42 17.1617 41.9062 17.0925 41.7386L15.2438 42.5016ZM8.07938 33.0184C11.8997 35.9275 14.0552 39.6834 15.2468 42.5087L17.0896 41.7315C15.8162 38.7123 13.4819 34.6185 9.29106 31.4272L8.07938 33.0184ZM0.730469 18.9765C0.730469 24.8508 3.72215 29.6891 8.07809 33.0174L9.29235 31.4282C5.329 28.3999 2.73047 24.1088 2.73047 18.9765H0.730469Z",
    fill: "#15192F",
    fillOpacity: 0.75,
    mask: "url(#path-1-outside-1)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.6892 11.554L14.9622 16.3207L9.8379 16.46C9.03103 16.4879 8.6913 17.4914 9.34245 17.9792L13.4051 21.0595L11.9612 25.9097C11.7347 26.6763 12.5982 27.3035 13.2777 26.8436L17.5102 23.9863L21.7427 26.8436C22.408 27.2896 23.2857 26.6763 23.0592 25.9097L21.6153 21.0595L25.6638 17.9792C26.3008 17.4914 25.9752 16.4879 25.1684 16.46L20.044 16.3207L18.3171 11.554C18.0481 10.8153 16.9723 10.8153 16.6892 11.554Z",
    fill: "#2C3248"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnd);
export default __webpack_public_path__ + "static/media/end.d6f9b1f2.svg";
export { ForwardRef as ReactComponent };